import { Component, Directive, Renderer, ElementRef, Input, ContentChildren, ContentChild, QueryList, ViewContainerRef, ViewChild, TemplateRef, forwardRef, HostBinding, Output, EventEmitter, Optional } from '@angular/core';
import { LyTheme, LyStyleTheme, themeProperty } from 'alyle-ui/core';
import { LyButton } from 'alyle-ui/button';
var idTab = 0;
var LyTabGroupComponent = /** @class */ (function () {
    function LyTabGroupComponent(elementRef, renderer, viewContainerRef, theme, styleTheme) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        this.theme = theme;
        this.styleTheme = styleTheme;
        this._bg = 'rgba(0, 0, 0, 0)';
        this._color = 'primary';
        this.tabRows = 0;
        this._selectedIndex = 0;
        this.tabWidth = 0;
        this.tabLeft = 0;
        this._isInitialized = false;
        this.selectedIndexChange = new EventEmitter();
    }
    Object.defineProperty(LyTabGroupComponent.prototype, "selectedIndex", {
        get: function () { return this._selectedIndex; },
        set: function (value) {
            if (this.tabs) {
                if (this.tabs.toArray()[value]) {
                    this.tabs.toArray()[value].setIndex(value);
                }
            }
            else {
                // this.updateTabsHeader();
                this._selectedIndex = value;
            }
            // if (value) {
            // }
            // if (this._isInitialized == true) {
            //   if (this.tabRows != this.tabs.length) {
            //     this.tabRows = this.tabs.length;
            //   }
            // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyTabGroupComponent.prototype, "bg", {
        set: function (val) {
            this._bg = val;
            this.styleBackground = this.theme.colorOf(this._bg);
            if (themeProperty(this._bg)) {
                this.styleColor = '#fff';
            }
            else {
                this.styleColor = this.theme.colorOf(this._color);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyTabGroupComponent.prototype, "color", {
        set: function (val) {
            this._color = val;
            if (themeProperty(this._bg)) {
                this.styleColor = '#fff';
            }
            else {
                this.styleColor = this.theme.colorOf(this._color);
            }
        },
        enumerable: true,
        configurable: true
    });
    LyTabGroupComponent.prototype._updateColor = function (bg) {
        /**
            // this.elementRef.nativeElement.setAttribute('style', `
            //   background: ${this._bg};
            //   color: ${this._color};
            // `);
            */
    };
    LyTabGroupComponent.prototype.ngAfterContentInit = function () {
        this.updateTabsHeader();
        this.tabRows = this.tabs.length;
    };
    LyTabGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscription = this.theme.palette.subscribe(function (colors) {
            _this.styleBackground = _this.theme.colorOf(_this._bg);
            _this.styleColor = _this.theme.colorOf(_this._color);
        });
    };
    LyTabGroupComponent.prototype.ngOnChanges = function (changes) {
        if (changes['selectedIndex']) {
            if (!changes['selectedIndex'].firstChange) {
                var index = changes['selectedIndex'].currentValue;
                var tabRef = this._tabsContent.nativeElement;
            }
        }
    };
    LyTabGroupComponent.prototype.setTab = function () {
    };
    LyTabGroupComponent.prototype.updateTab = function () {
        // this.updateTabsHeader();
    };
    LyTabGroupComponent.prototype.updateTabsHeader = function () {
        if (!this.tabs) {
            return;
        }
    };
    LyTabGroupComponent.prototype.ngAfterContentChecked = function () {
        if (this.tabRows != this.tabs.length && this._isInitialized == true) {
            this.tabRows = this.tabs.length;
            // this.updateTabsHeader();
        }
    };
    LyTabGroupComponent.prototype.ngAfterViewChecked = function () {
        this._isInitialized = true;
    };
    LyTabGroupComponent.prototype.updateTabIndicator = function (tab) {
        var _this = this;
        if (!tab) {
            return;
        }
        Promise.resolve(null).then(function () {
            _this.tabWidth = tab.offsetWidth;
            _this.tabLeft = tab.offsetLeft;
        });
    };
    LyTabGroupComponent.prototype.sMargin = function (tab, index) {
        if (index === 0) {
            this._margin = tab.offsetLeft * 2;
        }
    };
    LyTabGroupComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        /**
             * TODO: fix--> recibir el enevto del boton, crear evento del boton y actualizar line
             */
        this.tabs.forEach(function (item, index) {
            _this.sMargin(item.elementRef.nativeElement, index);
            item._index = index;
            var tabRef = item.elementRef.nativeElement;
            if (_this._selectedIndex == index && !!tabRef) {
                if (!!item.lyButton) {
                    Promise.resolve(null).then(function () {
                        item.lyButton.buttonPadding.subscribe(function (val) {
                            _this.updateTabIndicator(tabRef);
                        });
                    });
                }
                else {
                    _this.updateTabIndicator(tabRef);
                }
            }
        });
        this.tabs.changes.subscribe(function (tabs) {
            idTab = 0;
            tabs.forEach(function (item, index) {
                var tabRef = item.elementRef.nativeElement;
                _this.sMargin(tabRef, index);
                item._index = index;
                if (_this._selectedIndex == index && !!tabRef) {
                    _this.updateTabIndicator(tabRef);
                }
            });
        });
    };
    LyTabGroupComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ly-tab-group, ly-tabs',
                    styles: [":host { position: relative; display: block; } .ly-tab-header { height: 48px; width: 100%; position: relative; } .ly-tab-header::after { content: ' '; position: absolute; bottom: 0; left: 0; right: 0; height: 1px; background-color: rgba(0, 0, 0, 0.06); } .ly-tab-header-content { display: inline-flex; } .ly-tab-indicator { position: absolute; height: 2px; width: 0px; background: currentColor; bottom: 0; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms !important; } "],
                    template: "<div class=\"ly-tab-header\"> <ly-header-pagination> <div class=\"ly-tab-header-content\" [style.background]=\"styleBackground\" #tabsContent> <ng-content></ng-content> </div> <div class=\"ly-tab-indicator\" [style.color]=\"styleColor\" [style.width]=\"tabWidth+'px'\" [style.left]=\"tabLeft+'px'\"></div> </ly-header-pagination> </div> <div *ngFor=\"let item of tabs; let i = index\"> <div [hidden]=\"!(i == _selectedIndex)\"> <ng-template [ngTransclude]=\"item.templateRef\"></ng-template> </div> </div> <!-- <div [ngTransclude]=\"t.tabContent\" *ngFor=\"let t of tabs\"> ehhh </div> --> ",
                },] },
    ];
    /** @nocollapse */
    LyTabGroupComponent.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer, },
        { type: ViewContainerRef, },
        { type: LyTheme, },
        { type: LyStyleTheme, },
    ]; };
    LyTabGroupComponent.propDecorators = {
        "tabs": [{ type: ContentChildren, args: [forwardRef(function () { return LyTab; }),] },],
        "lyButton": [{ type: ContentChild, args: [LyButton,] },],
        "_tabsContent": [{ type: ViewChild, args: ['tabsContent',] },],
        "templateRef": [{ type: ViewChild, args: [TemplateRef,] },],
        "selectedIndex": [{ type: Input },],
        "selectedIndexChange": [{ type: Output },],
        "bg": [{ type: Input },],
        "color": [{ type: Input },],
    };
    return LyTabGroupComponent;
}());
export { LyTabGroupComponent };
var LyTabContent = /** @class */ (function () {
    function LyTabContent() {
    }
    LyTabContent.decorators = [
        { type: Directive, args: [{
                    selector: '[ly-tab-content]',
                },] },
    ];
    // @ViewChild(TemplateRef) content: TemplateRef<any>;
    // constructor() {}
    /** @nocollapse */
    LyTabContent.ctorParameters = function () { return []; };
    return LyTabContent;
}());
export { LyTabContent };
var LyTab = /** @class */ (function () {
    function LyTab(lyTabGroup, elementRef) {
        this.elementRef = elementRef;
        this._index = 0;
        this._indexGroup = 0;
        this.lyTabGroup = lyTabGroup;
        this._indexGroup = this.lyTabGroup._selectedIndex;
    }
    Object.defineProperty(LyTab.prototype, "tabStyles", {
        get: function () {
            var color = 'currentColor';
            if (this._index == this.indexGroup) {
                color = this.lyTabGroup.styleColor;
            }
            return {
                color: color,
            };
        },
        enumerable: true,
        configurable: true
    });
    LyTab.prototype.llOorr = function () {
        var arg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arg[_i] = arguments[_i];
        }
        return arg[0] < arg[1] ? 'r' : 'l';
    };
    LyTab.prototype.solt = function () {
    };
    LyTab.prototype.emitChange = function (index) {
        this.lyTabGroup.selectedIndexChange.emit(index);
    };
    LyTab.prototype.widthExacta = function (elem) {
        return elem.offsetWidth;
        // if (typeof elem.getBoundingClientRect !== typeof undefined) {
        //   return elem.getBoundingClientRect().width;
        // } else {
        //   return elem.offsetWidth;
        // }
    };
    LyTab.prototype.floor = function (num) {
        // return Math.round(num);
        return (num);
    };
    LyTab.prototype.setIndex = function (index) {
        var _this = this;
        var ev = this.elementRef.nativeElement;
        var restWi = 0;
        var tabLabel = this.elementRef.nativeElement;
        restWi = this.widthExacta(ev) - this.widthExacta(tabLabel);
        // ev = tabLabel as HTMLElement;
        var w = this.floor(this.lyTabGroup._tabsContent.nativeElement.offsetWidth);
        var llOorr = this.llOorr(this.lyTabGroup._selectedIndex, index);
        var prevIndex = this.lyTabGroup._selectedIndex;
        var eve;
        this.lyTabGroup._selectedIndex = index;
        // this.lyTabGroup.updateTabsHeader();
        var dW;
        var dL;
        // let outEf: any = setTimeout(() => {});
        // clearTimeout(outEf);
        if (this.lyTabGroup.timeout) {
            // this.lyTabGroup.timeout.callback();
            clearTimeout(this.lyTabGroup.timeout);
            this.lyTabGroup.timeout = null;
        }
        // if (tabLabel.className != 'ly-tab-label-item') {
        //   eve = getParents(tabLabel, '.ly-tab-label-item');
        //   dW = getParents(tabLabel, '.ly-tab-label-item').offsetWidth;
        //   dL = getParents(tabLabel, '.ly-tab-label-item').offsetLeft;
        // } else {
        eve = ev;
        dW = this.floor(tabLabel.offsetWidth);
        dL = this.floor(tabLabel.offsetLeft);
        // }
        if (llOorr === 'r') {
            // this.lyTabGroup.tabWidth = dW;
            // this.lyTabGroup.tabLeft  = dL;
            // this.lyTabGroup.tabWidth = w - dL;
            // this.lyTabGroup.tabLeft  = dL;
            var sibsW = 0;
            var sibsID = [];
            var thisW = eve.previousSibling.offsetWidth;
            // clearTimeout(outEf);
            this.lyTabGroup.timeout = setTimeout(function () {
                _this.lyTabGroup.tabWidth = dW;
                _this.lyTabGroup.tabLeft = dL;
                _this.lyTabGroup.timeout = null;
                _this.lyTabGroup.selectedIndexChange.emit(index);
            }, 475);
            while (eve = eve.previousSibling) {
                if (eve.nodeName === 'LY-TAB') {
                    sibsID.push(eve);
                }
            }
            sibsID.reverse();
            for (var i = 0; i < sibsID.length; i++) {
                if (prevIndex <= i) {
                    sibsW = sibsID[i].offsetWidth + sibsW + (this.lyTabGroup._margin || 0);
                }
            }
            this.lyTabGroup.tabWidth = sibsW + dW;
        }
        else if (llOorr === 'l') {
            var sibsW = 0;
            var sibsID = [];
            // let thisW = eve.previousSibling.offsetWidth;
            prevIndex = (this.lyTabGroup.tabRows - 1) - prevIndex;
            this.lyTabGroup.timeout = setTimeout(function () {
                _this.lyTabGroup.tabLeft = dL;
                _this.lyTabGroup.tabWidth = dW;
                _this.lyTabGroup.timeout = null;
                _this.lyTabGroup.selectedIndexChange.emit(index);
            }, 475);
            while (eve = eve.nextSibling) {
                if (eve.nodeName === 'LY-TAB') {
                    sibsID.push(eve);
                }
            }
            sibsID.reverse();
            for (var i = 0; i < sibsID.length; i++) {
                if (i >= prevIndex) {
                    sibsW = sibsID[i].offsetWidth + sibsW + (this.lyTabGroup._margin || 0);
                }
            }
            this.lyTabGroup.tabWidth = sibsW + dW;
            this.lyTabGroup.tabLeft = dL;
            // this.lyTabGroup.tabWidth = dW;
            // this.lyTabGroup.tabLeft  = dL;
        }
    };
    LyTab.prototype.updateTabLine = function () {
        // this.lyTabGroup._selectedIndex = index;
        // this.lyTabGroup.tabWidth = ev.offsetWidth;
        // this.lyTabGroup.tabLeft = ev.offsetLeft;
    };
    Object.defineProperty(LyTab.prototype, "indexGroup", {
        get: function () {
            this._indexGroup = this.lyTabGroup._selectedIndex;
            return this._indexGroup;
        },
        enumerable: true,
        configurable: true
    });
    LyTab.prototype.ngAfterViewInit = function () {
        this.stateTab = !(this._index == this.indexGroup);
        if (this.stateTab) {
            // this.lyTabGroup.tabWidth = this.elementRef.nativeElement.offsetWidth;
            // this.lyTabGroup.tabLeft = this.elementRef.nativeElement.offsetLeft;
        }
    };
    LyTab.prototype.ngAfterContentInit = function () {
        // this.lyTabGroup.updateTabsHeader();
        this.hostStyle = this.lyTabGroup.theme.AlyleUI.palette.primary.text;
    };
    LyTab.decorators = [
        { type: Component, args: [{
                    selector: 'ly-tab',
                    styles: [".ly-tab-label-item { position: relative; display: inline-block; min-width: 0px; height: 100%; overflow: hidden; text-align: center; line-height: 48px; cursor: pointer; box-sizing: border-box; } :host { margin: 0 8px; } :host /deep/ [ly-tab-label] { display: block; } .ly-tab-label-item /deep/ { -webkit-tap-highlight-color: transparent; } .ly-tab-label-item /deep/ [ly-button], .ly-tab-label-item /deep/ ly-button { height: 100%; vertical-align: top; border-radius: 0; } .ly-tab-label-item /deep/ .ly-button-padding-left { padding-left: 8px; } .ly-tab-label-item /deep/ .ly-button-padding-right { padding-right: 8px; } .ly-tab-label-item /deep/ ly-tab-label:not([ly-button]) { padding: 0 8px; display: inline-flex; white-space: nowrap; } "],
                    template: "<!-- <button ly-button (mousedown)=\"solt()\" (click)=\"setIndex(_index)\" class=\"ly-tab-label-item\"> <ng-content select=\"ly-tab-label\"></ng-content> </button> --> <div (mousedown)=\"solt()\" (click)=\"setIndex(_index)\" [ngStyle]=\"tabStyles\" class=\"ly-tab-label-item\" lyRipple> <ng-content select=\"ly-tab-label\"></ng-content> <ng-content select=\"[ly-tab-label]\"></ng-content> </div> <ng-template> <div> <ng-content></ng-content> </div> </ng-template> ",
                },] },
    ];
    /** @nocollapse */
    LyTab.ctorParameters = function () { return [
        { type: LyTabGroupComponent, decorators: [{ type: Optional },] },
        { type: ElementRef, },
    ]; };
    LyTab.propDecorators = {
        "lyButton": [{ type: ContentChild, args: [LyButton,] },],
        "hostStyle": [{ type: HostBinding, args: ['style.color',] },],
        "templateRef": [{ type: ViewChild, args: [TemplateRef,] },],
    };
    return LyTab;
}());
export { LyTab };
//# sourceMappingURL=tabs.js.map